export const actionCodeSettings = {
  url: `${window.location.origin}/login`,
  handleCodeInApp: false,
};
